import React, { Component } from "react";
import PropTypes from "prop-types";

import { ThreeJSWorldContext } from "web-store-modules/packages/web-store-three-world";
import { EFFECTS } from "web-store-modules/packages/three-transition";
import Marker from "./Marker.jsx";
import {
  MovedOnce,
  InteractedOnce,
  ArrowClicked,
  GifNavigationClick,
  ArrowPanelClicked,
} from "../../utils/Analytics.js";
import {
  getAllSceneInfoDictAsync,
  getSceneIds,
  getTrasitionTypeAsync,
  isExhibit,
} from "../../utils/StoreConfigManager.js";
import {
  isRoomMarkerClicked,
  addClickedRoomMarker,
} from "../../utils/DynamicStoreDataManager.js";
import ArrowSvg from "./ReactSVGArrows/ArrowSvg.jsx";
import CenterArrowSvg from "./ReactSVGArrows/CenterArrowSvg.jsx";
import StairsUpSvg from "./ReactSVGArrows/StairsUpSvg.jsx";
import StairsDownSvg from "./ReactSVGArrows/StairsDownSvg.jsx";
import { AppContext } from "../../AppContext.jsx";

const gifNavigationIds = [
  "615b792ecd34a271429753de-615b796dd7bb008cbec5b33d",
  "615b792ecd34a271429753de-614152899ed97ea76b0905f1",
  "615b792ecd34a271429753de-615e9db83e65081526eb2466",
  "615b796dd7bb008cbec5b33d-615b792ecd34a271429753de",
  "615b796dd7bb008cbec5b33d-614152899ed97ea76b0905f1",
  "615b796dd7bb008cbec5b33d-615e9db83e65081526eb2466",
  "614152899ed97ea76b0905f0-614152899ed97ea76b0905f1",
  "614152899ed97ea76b0905f0-615e9db83e65081526eb2466",
  "614152899ed97ea76b0905f1-615b796dd7bb008cbec5b33d",
  "614152899ed97ea76b0905f1-614152899ed97ea76b0905f1",
  "614152899ed97ea76b0905f1-615e9db83e65081526eb2466",
  "615b78b1a1325877e1ac6494-615b796dd7bb008cbec5b33d",
  "615b78b1a1325877e1ac6494-615e9db83e65081526eb2466",
  "615b78b1a1325877e1ac6494-614152899ed97ea76b0905f1",
  "615e9db83e65081526eb2466-614152899ed97ea76b0905f1",
  "615e9db83e65081526eb2466-615b796dd7bb008cbec5b33d",
];
const CMSTemplateNavSpriteMap = Object.freeze({
  up: ArrowSvg,
  down: ArrowSvg,
  left: ArrowSvg,
  right: ArrowSvg,
  up_left: ArrowSvg,
  down_left: ArrowSvg,
  up_right: ArrowSvg,
  down_right: ArrowSvg,
  stairs_up: StairsUpSvg,
  stairs_down: StairsDownSvg,
});

const centerNavIdsArr = ["62508aa2b452e0eb474fda7a"];
class NavMarker extends Component {
  constructor(props) {
    const { id, hotspotId } = props;
    super(props);
    this.onClick = this.onClick.bind(this);

    const spriteNames = CMSTemplateNavSpriteMap[props.spriteType];
    this.state = {
      svgSprite: centerNavIdsArr.includes(hotspotId)
        ? CenterArrowSvg
        : spriteNames,
      linkedRoom: {},
      transitionType: EFFECTS.ZOOM_FADE,
    };

    this.sceneIds = [];
  }

  componentDidMount() {
    getSceneIds()
      .then((sceneIds) => (this.sceneIds = sceneIds))
      .catch((error) => console.error(error));
    this.getLinkedRoomData();
    this.getTransitionType();
  }

  async getLinkedRoomData() {
    try {
      const { linkedRoomId } = this.props;
      const sceneInfoDict = await getAllSceneInfoDictAsync();

      if (!sceneInfoDict[linkedRoomId]) {
        throw new Error("Scene with id " + linkedRoomId + " do not exist!");
      }

      this.setState({ linkedRoom: sceneInfoDict[linkedRoomId] });
    } catch (error) {
      console.log(error);
    }
  }

  async getTransitionType() {
    try {
      const transitionType = await getTrasitionTypeAsync();

      if (!transitionType) {
        throw new Error("Transition type do not exist!");
      }

      this.setState({ transitionType });
    } catch (error) {
      console.log(error);
    }
  }

  onClick() {
    const { id, threeJSWorldContext, hotspotId } = this.props;
    const { linkedRoom, transitionType } = this.state;
    if (gifNavigationIds.includes(id)) {
      GifNavigationClick(linkedRoom.name);
    }
    MovedOnce();
    InteractedOnce();
    addClickedRoomMarker(id);

    function loadNewScene() {
      const targetPath = "/" + linkedRoom.name;
      if(isExhibit){
        switch (hotspotId) {
          case "62508aa2b452e0eb474fda7a":
            ArrowPanelClicked(linkedRoom.name, "Left");
            break;
          case "62508aa2b452e0eb474fda78":
            ArrowPanelClicked(linkedRoom.name, "Right");
            break;
          case "62508aa2b452e0eb474fda7c":
            ArrowPanelClicked(linkedRoom.name, "Down");
            break;
          case "62508aa2b452e0eb474fda79":
            ArrowPanelClicked(linkedRoom.name, "Up");
            break;
          default:
            ArrowClicked(linkedRoom.name);
            break;
        }
      }
      else {
        ArrowClicked(linkedRoom.name);
        ArrowPanelClicked(linkedRoom.name);
      }
      threeJSWorldContext.pushHistoryWithReset(targetPath);
    }

    threeJSWorldContext.onClick(loadNewScene, transitionType);
  }

  render() {
    const { svgSprite } = this.state;
    return (
      <div>
        <Marker
          transform={this.props.transform}
          colliderTransform={this.props.colliderTransform}
          svgSprite={svgSprite}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
          rotationAngle={this.props.rotationAngle}
          showVisual={this.props.showVisual}
          onClick={this.onClick}
          arrowType={"Nav"}
          fade={this.props.canFade && isRoomMarkerClicked(this.props.id)}
          navMarkerId={this.props.id}
        />
      </div>
    );
  }
}

NavMarker.propTypes = {
  id: PropTypes.string.isRequired, // '{roomId}-{linkedRoomId}'
  transform: PropTypes.array.isRequired,
  colliderTransform: PropTypes.array.isRequired,
  linkedRoomId: PropTypes.string.isRequired,
  spriteType: PropTypes.string.isRequired,
  canFade: PropTypes.bool.isRequired,
  showVisual: PropTypes.bool,
  setLoadingIconVisibility: PropTypes.func,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  rotationAngle: PropTypes.number,
};

export default (props) => (
  <AppContext.Consumer>
    {(appContextValue) => (
      <ThreeJSWorldContext.Consumer>
        {(threeJSWorldContext) => (
          <NavMarker
            {...props}
            threeJSWorldContext={threeJSWorldContext}
            setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
          />
        )}
      </ThreeJSWorldContext.Consumer>
    )}
  </AppContext.Consumer>
);
